const categoryList = [
  { id: 1, value: 'Missed approach/go-round' },
  { id: 2, value: 'Unstable approach' },
  { id: 3, value: 'Delay' },
  { id: 4, value: 'Airspace violation' },
  { id: 5, value: 'Diversion' },
  { id: 6, value: 'Runway incursion (ACFT, VEHICLE, PERSON, or ANIMAL - RI)' },
  { id: 7, value: 'Airprox ACAS ALERT/LOSS OF SEPARATION/NEAR OR MIDAIR COLLISION (MAC)' },
  { id: 8, value: 'Bird strikes (BIRDS)' },
  { id: 9, value: 'VVIP' },
  { id: 10, value: 'Cancellation of flight' },
  { id: 11, value: 'EQPT, NAV AIDS, ATC, AND CNS Facility Failure/Malfunctioning (ATM/CNS)' },
  { id: 12, value: 'Emergency' },
  { id: 13, value: 'Aborted take-off' },
  { id: 14, value: 'Radio comm failure' },
  { id: 15, value: 'Tyre burst' },
  { id: 16, value: 'Did not comply with ATC Instruction' },
  { id: 17, value: 'No estimates passed to ATC' },
  { id: 18, value: 'Airside surfaces' },
  { id: 19, value: 'General' },
  { id: 20, value: 'AERODROME (ADRM)' },
  { id: 21, value: 'ACCIDENT/INCIDENT (ADREP)' },
  { id: 22, value: 'ABRUPT MANEUVER (AMAN)' },
  { id: 23, value: 'ABNORMAL RUNWAY CONTACT (ARC)' },
  { id: 24, value: 'ATC' },
  { id: 25, value: 'UNINTENDED FLIGHT INTO IMC CONDITIONS (IMC) BY VFR FLIGHTS' },
  { id: 26, value: 'CABIN SAFETY EVENTS (CABIN)' },
  { id: 27, value: 'CONTROLLED FLIGHT INTO TERRAIN (CFIT)' },
  { id: 28, value: 'COLLISION WITH OBSTACLES DURING TAKEOFF AND LANDING (CTOL)' },
  { id: 29, value: 'EVACUATION - PERSONS INJURED DURING EVACUATION (EVAC)' },
  { id: 30, value: 'FIRE/SMOKE WITHOUT IMPACT (F-NI)' },
  { id: 31, value: 'RUNWAY EXCURSION VEER OFF RUNWAY DURING TAKEOFF OR LANDING (RE)' },
  { id: 32, value: 'LOSS OF CONTROL OR DEVIATION - IN FLIGHT (LOC-I)' },
  { id: 33, value: 'Accumulation of snow, ice, freezing rain, or frost (ICE)' },
  { id: 34, value: 'FIRE/SMOKE - POST IMPACT (F-POST)' },
  { id: 35, value: 'R2' },
  { id: 36, value: 'Weather' },
  { id: 37, value: 'R1' },
  { id: 38, value: 'SECURITY RELATED HIJACK/UNRULY PAX/INTERFERENCE (SEC)' },
  { id: 39, value: 'SYSTEM/COMPONENT FAILURE NON POWER PLANT (SCF-NP)' },
  { id: 40, value: 'POWER PLANT FAILURE OF AN ACT (SCF-PP)' },
  { id: 41, value: 'GROUND HANDLING - JET BLAST/COLLISIONS DURING BOARDING, LOADING, SERVICING (RAMP)' },
  { id: 42, value: 'TURBULENCE IN-FLIGHT (TURB)' },
  { id: 43, value: 'TOUCHDOWN OFF RUNWAY SURFACE (USOS - UNDERSHOOT/OVERSHOOT)' },
  { id: 44, value: 'LANDING ENROUTE DUE TO LOSS OF LIFTING (LOLI)' },
  { id: 45, value: 'FLIGHT INTO WINDSHEAR OR THUNDERSTORM/HEAVY RAIN (WSTRW)' },
  { id: 46, value: 'COLLISION WHILE TAXING - NOT ON RUNWAY IN USE (GCOL)' },
  { id: 47, value: 'COLLISION/NEAR COLLISION WITH OBSTACLES/TERRAIN/OBJECTS WHILE INTENTIONALLY OPERATING NEAR THE SURFACE (LALT)' },
  { id: 48, value: 'GLIDER TOWING RELATED EVENTS (GTOW)' },
  { id: 49, value: 'UNKNOWN OR UNDETERMINED - NIL INFORMATION, MISSING AFT (UNK)' },
  { id: 50, value: 'FUEL RELATED - REDUCED FUEL (FUEL)' },
];

export default categoryList;
